import React from "react";
import { Avatar } from "@mui/material";
import useOcAvatarDI from "oc/hooks/use-avatar";

interface OcAvatarProps {
  employee: string; // Replace 'any' with the appropriate type for 'employee'
  style?: React.CSSProperties;
  className?: string;
  useOcAvatar?: typeof useOcAvatarDI;
}

export const OcAvatar: React.FC<OcAvatarProps> = ({
  employee,
  style,
  className,
  useOcAvatar = useOcAvatarDI,
}) => {
  const { data } = useOcAvatar({ employee });
  return (
    <Avatar
      id="avatar-img"
      alt="avatar-image"
      style={style}
      src={data}
      className={className}
    />
  );
};

export default OcAvatar;
